/* HDD 购买会员 */

import { inject, observer } from 'mobx-react';
import { getUserInfo } from '@/api/Dialogs/signUpDlg';
import BuyMember from '&/pages/rendering-voucher/components/buyMember';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './index.scss';

function BuyMemberModal(props) {
    const { appStore, location } = props;
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const index = params.get('index');
    const [memberIndex, setMemberIndex] = useState('0');
    const [userInfo, setUserInfo] = useState({});
    const [visible, setVisible] = useState(false);
    usePreventDefault();

    const init = async () => {
        if (index) setMemberIndex(index);
        if (token) {
            appStore.setLoginData({ token }, false);
            await queryUserInfo();
            setVisible(true);
        }
    };

    useEffect(init, []);

    const queryUserInfo = async () => {
        try {
            const { data } = await getUserInfo();
            setUserInfo(data);
            return localStorage.setItem('HDDUserData', JSON.stringify(data));
        } catch (e) {
            console.log(e);
        }
    };
    const paySuccess = async (memberData, expireDate) => {
        await queryUserInfo(); // 开通会员成后需要，重新查询个人消息，同步到 hdd 端

        try {
            const memberParam = {
                date: expireDate,
                name: memberData.name,
            };
            const urlParams = `?token=${token}&member=${JSON.stringify(
                memberParam
            )}`;
            const sendData = {
                Url: `${window.location.origin}/hdd/buySuccessModal${urlParams}`,
                Width: 280,
                Height: 242,
            };
            window.external.DispatchFun(
                'StartPage',
                'ReloadUrl',
                JSON.stringify(sendData)
            );
        } catch (e) {
            console.log(e);
        }
    };

    const hide = () => {
        window.external.DispatchFun('StartPage', 'CloseRender', '');
    };

    return (
        <div className="buy-rendering-coupons-modal">
            <BuyMember
                isHDD
                showClose={true}
                userInfo={userInfo}
                memberIndex={memberIndex}
                visible={visible}
                afterSuccess={paySuccess}
                hide={hide}
            />
        </div>
    );
}
export default inject('appStore')(observer(BuyMemberModal));
